import Blockly from "blockly/core";
import "./core";
import "blockly/blocks";

export default Blockly;
